import { Row, Col } from 'antd'
import { useTranslation } from 'react-i18next'

import { I18NService } from 'services'
import { InputTitle } from 'components'

import { Title, Space, FlexCol, Ball, MarginRow, Divider } from './components'
import { UpdateRiceLotVariables } from '../../api'
import { useBody } from './hooks'

interface Props {
  lotId: number
  previousCropId?: number
  riceLotId: number
  emergenceDate?: string
  plantingDate?: string
  firstIrrigationStartDate?: string
  firstIrrigationEndDate?: string
  floweringDate?: string
  harvestDate?: string
  physiologicalMaturityDate?: string
  differentiationDate?: string
  preparationDate?: string
  burningDate?: string
  earAppearanceDate?: string
  updateRiceLotMutation: (updateRiceLotDTO: { variables: UpdateRiceLotVariables }) => void
}

export const Timeline: React.FC<Props> = ({
  lotId,
  previousCropId,
  riceLotId,
  plantingDate,
  emergenceDate,
  firstIrrigationStartDate,
  firstIrrigationEndDate,
  floweringDate,
  harvestDate,
  differentiationDate,
  physiologicalMaturityDate,
  preparationDate,
  burningDate,
  earAppearanceDate,
  updateRiceLotMutation,
}) => {
  const { t } = useTranslation(I18NService.NAMESPACES.LOT_DASHBOARD)

  const { bodyData, ballBackground } = useBody({
    lotId,
    previousCropId,
    riceLotId,
    plantingDate,
    emergenceDate,
    firstIrrigationStartDate,
    firstIrrigationEndDate,
    floweringDate,
    harvestDate,
    differentiationDate,
    physiologicalMaturityDate,
    preparationDate,
    burningDate,
    earAppearanceDate,
    updateRiceLotMutation,
  })

  return (
    <Space direction="vertical" size={24}>
      <Row>
        <Col>
          <Title level={5}>{t('timeline.title')}</Title>
        </Col>
      </Row>
      <Row>
        {bodyData.map(timelineObject => {
          return (
            <Col span={24} key={timelineObject.title}>
              <Row gutter={[24, 0]}>
                <FlexCol>
                  <Ball
                    $completedDate={timelineObject.completedDate}
                    $backgroundColor={ballBackground}
                  />
                  <Divider />
                </FlexCol>
                <MarginRow>
                  <Col>
                    <InputTitle title={timelineObject.title} />
                  </Col>
                  <Col flex={1}>{timelineObject.component}</Col>
                </MarginRow>
              </Row>
            </Col>
          )
        })}
      </Row>
    </Space>
  )
}
